import React, { ReactNode } from 'react';
interface FormCardProps {
  title: string;
  description?: string | ReactNode;
  children: React.ReactNode;
}
export function FormCard({
  title,
  description,
  children
}: FormCardProps) {
  return <div className="border rounded-md p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-grandpal-green-dark">{title}</h3>
        {description && (typeof description === 'string' ? <p className="text-sm text-grandpal-gray mt-1">{description}</p> : <div className="text-sm text-grandpal-gray mt-1">{description}</div>)}
      </div>
      {children}
    </div>;
}